import {Route, Routes} from "react-router-dom";
import React from "react";
import Home from "../components/pages/Home";
import Fkp from "../components/pages/Voc/Fkp";
import CodeGroup from "../components/pages/Voc/CodeGroup";
import Exporter from "../components/pages/Voc/Exporter";
import Importer from "../components/pages/Voc/Importer";
import Client from "../components/pages/Voc/Client";
import Kodfito from "../components/pages/Voc/Kodfito";
import ByOrder from "../components/pages/Voc/ByOrder";
import Unit from "../components/pages/Voc/Unit";
import DestPlace from "../components/pages/Voc/DestPlace";
import TnvedSergio from "../components/pages/Voc/TnvedSergio";
import Markings from "../components/pages/Voc/Markings";
import Postavka from "../components/pages/Postavka";
import Production from "../components/pages/Voc/Production";
import Report from "../components/pages/Report";
import UsersWithAccess from "../components/pages/Users";
import VocWithAccess from "../components/pages/Voc/Voc";
import EntryWithAccess from "../components/pages/Entry";
import StartWithAccess from "../components/pages/Start";
import ViewWithAccess from "../components/pages/View";
import HistoryWithAccess from "../components/pages/History";

export default function MasterRoute() {
    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/authorizations' element={<StartWithAccess />} />
            <Route path='/users' element={<UsersWithAccess />} />
            <Route path='/entry' element={<EntryWithAccess />} />
            <Route path='/view' element={<ViewWithAccess />} />
            <Route path="/view/:id" element={<Postavka />} />
            <Route path="/report" element={<Report />} />
            <Route path="/history" element={<HistoryWithAccess />} />
            <Route path='/voc' element={<VocWithAccess />} >
                <Route path="/voc/fkp" element={<Fkp />} />
                <Route path="/voc/code_group" element={<CodeGroup />} />
                <Route path="/voc/exporter" element={<Exporter />} />
                <Route path="/voc/importer" element={<Importer />} />
                <Route path="/voc/client" element={<Client />} />
                <Route path="/voc/kodfito" element={<Kodfito />} />
                <Route path="/voc/by_order" element={<ByOrder />} />
                <Route path="/voc/unit" element={<Unit />} />
                <Route path="/voc/dest_place" element={<DestPlace />} />
                <Route path="/voc/tnved_sergio" element={<TnvedSergio />} />
                <Route path="/voc/markings" element={<Markings />} />
                <Route path="/voc/production" element={<Production />} />
            </Route>
        </Routes>
    )
}